import {filterData} from "../components/DropdownFilter";

export const filterCategoryData = (categories: filterData[],
    companyCategories: any[]) => {
        const category = companyCategories.map((data)=> {
            const index = categories.findIndex((category)=>
                category.id === data.categoryId);
            return {...categories[index], groupId: data.companyCategoryId};
        });
        return category;
    }